import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { changeQuantity } from 'store/popups';
import { usePopup } from 'hooks/usePopup';
import { useSoundPath } from 'hooks/useSoundPath';
import useActiveItem from 'hooks/useActiveItem';
import ActiveItemDivider from './ActiveItemDivider';

const ActiveactiveItemPrice = () => {

  const dispatch = useDispatch();
  const {activeItem} = useActiveItem();
  const setPopupHook = usePopup();
  const playSound = useSoundPath();
  const currentQuantity = useSelector((state) => state.popups.quantityPurchase);
  const [resultSum, setResultSum] = useState(0);

  const openPurchaseWindow = () => {
    playSound('main');
    setPopupHook({type: 'purchase'})
  }

  const increaseSum = () => {
    dispatch(changeQuantity(currentQuantity + 1))
    playSound('main');
  }

  const decreaseSum = () => {
    if (currentQuantity >= 2) {
      dispatch(changeQuantity(currentQuantity - 1))
      playSound('main');
    }
  }

  const inputHandler = (e) => {
    dispatch(changeQuantity(Number(e.target.value)))
  }

  useEffect(() => {
    setResultSum(Number(activeItem.cost))
  }, [activeItem]);

  useEffect(() => {
    setResultSum(Number(activeItem.cost) * currentQuantity)
  }, [currentQuantity]);

  useEffect(() => {
    dispatch(changeQuantity(1))
  }, [activeItem]);


  return (
    <div className='card-details__card-purchase'>
      <section className="card-details__card card-details__card--price">
        <h3 className="card-details__title">Multi-Pack Purchase</h3>
        <div className="card-details__price-calc">
          <p className="card-details__price-main">
            <span>Price</span>
            <span>${activeItem.cost} USD</span>
          </p>
          <div className="card-details__price-quantity">
            <span>Quantity</span>
            <p className="card-details__price-actions">
              <button className="increase" onClick={decreaseSum}>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33301 10.5H16.6663" stroke="currentColor" strokeWidth="1.6"
                    strokeLinecap="square" />
                </svg>
              </button>
              <input type="number" min={1} value={currentQuantity} onInput={inputHandler} />
              <button className="decrease" onClick={increaseSum}>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.99967 3.83301V10.4997M9.99967 10.4997V17.1663M9.99967 10.4997H3.33301M9.99967 10.4997H16.6663"
                    stroke="currentColor" strokeWidth="1.6" strokeLinecap="square" />
                </svg>
              </button>
            </p>
          </div>
          <p className="card-details__price-total">
            <span>Total</span>
            <span>${resultSum.toFixed(2)} USD</span>
          </p>
        </div>
      </section>

      <button className="card-details__buy-now" onClick={openPurchaseWindow}>Buy now</button>

      <ActiveItemDivider />
    </div>
  )
}

export default ActiveactiveItemPrice;
